import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { MainAppProvider } from 'contexts/MainAppContext';
import { ProductsProvider } from 'contexts/ProductsContext';
import { TimeSeriesProvider } from 'contexts/TimeSeriesContext';
import MapModeView from './components/MapViewLayout/components/MapModeView';
import MapViewLayout from './components/MapViewLayout';
import TimeSeriesPlayer from './components/MapViewLayout/components/TimeSeriesPlayer';
import { CrossSectionProvider } from '../../contexts/CrossSectionContext';
import { RealTimeProvider } from '../../contexts/RealTimeContext';
import { BaseLayerProvider } from '../../contexts/BaseLayerContext';
import { ADSBProvider } from '../../contexts/ADSBContext';
import UtilsMenu from './components/MapViewLayout/components/UtilsMenu';
import { GlobalMapCommandsProvider } from '../../contexts/GlobalMapCommandsContext';

function MapView() {
  return (
    <DndProvider backend={HTML5Backend}>
      <ProductsProvider>
        <MainAppProvider>
          <TimeSeriesProvider>
            <CrossSectionProvider>
              <RealTimeProvider>
                <BaseLayerProvider>
                  <ADSBProvider>
                    <GlobalMapCommandsProvider>
                      <MapViewLayout>
                        <UtilsMenu />
                        <MapModeView />
                        <TimeSeriesPlayer />
                      </MapViewLayout>
                    </GlobalMapCommandsProvider>
                  </ADSBProvider>
                </BaseLayerProvider>
              </RealTimeProvider>
            </CrossSectionProvider>
          </TimeSeriesProvider>
        </MainAppProvider>
      </ProductsProvider>
    </DndProvider>
  );
}

export default MapView;
